import { Controller } from "@hotwired/stimulus"

// This controller is used to toggle a css class on an element.
export default class extends Controller {
  static get targets() {
    return ["preview", "video"]
  }

  play() {
    this.element.classList.add("is-playing")
  }
}
